import { useState, useEffect, useRef  } from 'react';
import {Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton} from '@mui/material';

import { CcActionButton } from '../commonComponents/styledTexts';
import { FileDropZone, LionListbox } from '../commonComponents/inputFields';

import { lionIcons } from '../components/helpersIcons';

import axios from 'axios';
import { Icon as Iconify } from '@iconify/react';
import opentype from 'opentype.js'

const extractFontInfo = (font) => {
  if (font === undefined) return {hasVariations: false, instances: [], valid: false}

  const result = {valid: true}
  //console.log(font);
  result.names = JSON.parse(JSON.stringify(font.tables.name));
  if (result.names.designer === undefined) result.names.designer = {en: "Not found"}
  if (result.names.manufacturer === undefined) result.names.manufacturer = {en: "Not found"}
  if (result.names.license === undefined) result.names.license = {en: "Not found"}
  result.glyphs = font.glyphs
  
if (font.tables.fvar && font.tables.fvar.axes) {
    if (font.tables.fvar.axes.length > 0) {
      result.hasVariations = true;
      if (font.tables.fvar.instances) result.instances = JSON.parse(JSON.stringify(font.tables.fvar.instances));
      //if (font.tables.fvar.instances) result.instances = font.tables.fvar.instances.map(i => i.name.en)
    }
  }
  //console.log(result)
  return result;
}


const FontCardInfo = (props) => {
  const canvasRef = useRef(null)
  const [showEditName, setShowEditName] = useState(false)
  const [editName, setEditName] = useState(false)
  const [newName, setNewName] = useState(false)
  const [currentName, setCurrentName] = useState('')
  const [dialogInfoOpen, setDialogInfoOpen] = useState(false);
  const [fontInfo, setFontInfo] = useState({hasVariations: false, instances: [], glyphs: {lenght:0, glyphs:{}}}); //convenient obj to store parsed font info

  useEffect(() => {
    if (props.fontInfo === undefined) return;

    setCurrentName(props.fontInfo.prettyName)
    const buffer = base64ToArrayBuffer(props.fontInfo.previewFontB64)
    const f = opentype.parse(buffer);
    //console.log(f)


    setFontInfo(extractFontInfo(f));
  }, [props.fontInfo])

  const base64ToArrayBuffer = (base64) => {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }



  return <div style={{boxShadow: '0px 0px 8px 2px rgba(0,0,0,0.5)'}} className=' rounded-md p-2'>
    <div className='grid grid-cols-12'>
    </div>

    <Dialog onClose={() => setDialogInfoOpen(false)} open={dialogInfoOpen}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-font"
                maxWidth="lg" fullWidth
        >
            <DialogTitle id="dialog-title"><span className='text-ccColorDarkTeal'>Font details</span></DialogTitle>
            <DialogContent>
            </DialogContent>
                <DialogActions>
                <Button onClick={() => setDialogInfoOpen(false)}>Close</Button>
                </DialogActions>

        </Dialog>

  </div>
}

const FilesViewer = (props) => {
    
    const generateSymbols = () => {
        const result = [{id: '', name: 'Not selected'}]
        for (let i =32; i<=126; i+=1) {
            const currentChar = String.fromCharCode(i)
            let currentCharPretty = currentChar
            switch (currentChar) {
                case " ":
                    currentCharPretty = '(space)'
                break;
                default:
                break
            }
            result.push({id: currentChar, name: currentCharPretty})
        }
        return result
    }
    const symbols = generateSymbols()
    const handleDelete = (file) => {
        if (props.onRequestDelete) props.onRequestDelete(file)
    }
    
    return <div className='flex flex-row flex-wrap items-center gap-4'>
        {props.files.map(f => <div className='flex flex-col'>
            <div className='bg-slate-200 rounded p-4 mt-2 w-[320px] h-[240px] flex justify-center relative'>
                <div className=' h-full' >

                    <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${f.dataB64}`} />
                </div>
                <div className=' absolute top-0 right-0'>
                    <IconButton 
                        onClick={() => handleDelete(f)}
                    ><Iconify icon={lionIcons.Icon_Actions_Cancel} width={36} /></IconButton>

                </div>                
            </div>
            <LionListbox items={symbols}
                zIndex={10}
                //selectedItemId={weatherIconsCollectionId}
                //onChange={(val) => setWeatherIconsCollectionId(val.id)}
            />

        </div>)}
    </div>
}

export default function PageAdminArtFonts() {
    /*
    props:

    NO props 
    */
    const [fonts, setFonts] = useState([]); //fonts in user account
    const [filesData, setFilesData] = useState([]); //files to be uploaded
    const [filesFamilyName, setFilesFamilyName] = useState([]); //when multiple files are uploaded, it contains the name of the family
    const [currentFontId, setCurrentFontId] = useState(0); //if 0 it means we are uploading files for a new font. if >0  it is used to update the files of an existing font
    const [selectedFileIndex, setSelectedFileIndex] = useState(0);
    const [fontInfo, setFontInfo] = useState({hasVariations: false, instances: []}); //convenient obj to store parsed font info
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [addEditMode, setAddEditMode] = useState(false);

    useEffect(() => {
      getFonts();
    }, [])

    const getFonts = async() => {
        setShowLoader(true)
        try {
          const url = `${process.env.REACT_APP_LION_API_URL}/User/Fonts`;
  
          const response = await axios.get(url);

          setFonts(response.data)

        } catch (error) {
          setShowError(true)
        }
        finally {
          setShowLoader(false);

        }

    }
  const uploadFont = async(dataToPost, fontId) => {
      //console.log(dataToPost)
        setShowLoader(true)
        try {
          let url = `${process.env.REACT_APP_LION_API_URL}/User/UploadFont`;
          if (fontId) url = `${process.env.REACT_APP_LION_API_URL}/User/UploadFont/${fontId}`;

          const response = await axios.post(url, dataToPost);
          getFonts()
          if (response.data === true) {
            setShowSuccess(true)
          }
          else {
              setShowError(true)
          }

        } catch (error) {
          setShowError(true)
        }
        finally {
          setShowLoader(false);

        }

    }

    const handleFontLoaded = (files, fontId) => {
      //files has this format [{fName: '', data: arrayBuffer}]
      //we want to add a field with the parsed font
      if (fontId) setCurrentFontId(fontId)
      else setCurrentFontId(0)

      if (files && files.length > 0) {
        const newFiles = [...filesData]
        for (const f of files) newFiles.push({...f, mapping: ''})
        
        setFilesData(newFiles)
        }
    }
    
    

    const prepareDataToPost = () => {
      /*
      we need to prrepare an object like:
      {name: name,
      styles: [{weight: 100, italics: false}]
      data: [fontArr base64] 
      }
      */
     const results = {name: filesFamilyName, styles: [], data: []}
      filesData.forEach(f => {
        if (f.validFile && (f.hasVariations === undefined || f.hasVariations === false) && f.sameFamily) {
          //we only loop through valid files
          const weight = f.font.tables.os2.usWeightClass 
          const fsSelection = f.font.tables.os2.fsSelection 
          const italics = fsSelection & 1 //the first bit of fsSelection is the italics flag
          results.styles.push({weight: weight, italics: Boolean(italics)})
          results.data.push(f.dataB64)
        }
      })
      return results;
    }

  const handleFontSelected = (index) => {

    }

  const handleUpdateFontFiles = (files, fontId) => {
    handleFontLoaded(files, fontId)
  }
  const handleDeleteFile = (file) => {
    const newFilesData = [...filesData]
    const index = newFilesData.findIndex(f => f.fName === file.fName)
    if (index !== -1) newFilesData.splice(index, 1)
    
    setFilesData(newFilesData)
}

    return <div>
            <div className='text-ccColorDarkTeal text-lg font-semibold'>Art Fonts</div>
          <div className='mb-2 text-ccColorDarkTeal'>Upload an image for each letter. For better results all images should have the same height</div>
        {!addEditMode &&
            <CcActionButton onClick={() => setAddEditMode(true)}>Create new art font</CcActionButton>
        }
        <div className='h-4'></div>
        {fonts.length === 0 && <div>
            No fonts defined
        </div>}
        {addEditMode && <div>
                <FileDropZone
                        multiple
                    accept="image/*"
                    onFilesSelected={handleFontLoaded}                
                />
                <FilesViewer files={filesData}
                onRequestDelete={handleDeleteFile}
                />

            </div>}
        {!addEditMode && 
            <div className='flex flex-col gap-y-6'>
            {fonts.map(f => <FontCardInfo fontInfo={f} onUploadFiles={handleUpdateFontFiles} />  )

            }
            </div>
        }


    </div>
}